import { hanhtrangsoClient } from 'configs/api';
import { generateSHA1 } from 'helpers/CryptoHelper';
import { queryFirst } from 'helpers/QueryHelper';
import _ from 'lodash';

export async function hanhtrangsoLogin(email = '', password = '') {
  try {
    const response = await hanhtrangsoClient.post('/login', { email, password });

    const { accessToken } = response.data.data;
    // GET MORE INFORMATION
    const baseInfo = await hanhtrangsoClient.get('/Home/GetBaseInfo', { headers: { Authorization: `Bearer ${accessToken}` } });

    return {
      ...response.data.data.userProfile,
      ...baseInfo.data.data,
      ...{
        accessToken: response.data?.data?.accessToken,
        refreshToken: response.data?.data?.refreshToken,
        password,
        role: response.data.data.userProfile.roleCode === 'PUPIL' ? 'student' : 'teacher',
        ...baseInfo.data.data.userProfile,
      },
    };
  } catch (error) {
    throw new Error(error);
  }
}

export async function sachsoRegister(hanhtrangsoUser) {
  const { email, password } = hanhtrangsoUser;
  const fullName = `${hanhtrangsoUser.firstName} ${hanhtrangsoUser.lastName}`;
  const roleId = hanhtrangsoUser.roleCode === 'PUPIL' ? 1 : 2;
  const { schoolTypeId } = hanhtrangsoUser;
  const { city: cityId } = hanhtrangsoUser;
  const { phoneNumber: phone } = hanhtrangsoUser;

  try {
    const registeredUser = await queryFirst('p_SACHSO_Users_Register', { email, password: generateSHA1(password), fullName, roleId, schoolTypeId, cityId, phone });
    return registeredUser;
  } catch (error) {
    throw new Error(error);
  }
}

export async function sachsoLogin(email = '', password = '') {
  try {
    const loggedInUser = await queryFirst('p_SACHSO_Users_Login', { email, password: generateSHA1(password) });
    const finalUser = { ...loggedInUser, accessToken: '', refreshToken: '', password };
    if (!loggedInUser) return undefined;
    //lấy role là id cao nhất
    const finalRole = _.maxBy(loggedInUser.roles ?? [], ['id']);
    if (finalRole) {
      finalUser.role = finalRole?.name?.toLowerCase();
    } else {
      finalUser.role = 'null';
    }

    return finalUser;
  } catch (error) {
    throw new Error(error);
  }
}
